import { useEffect, useState } from 'react';

import { RoundInfo, RoundService, TimeLeft } from '@services/roundService';

/**
 * Hook that provides live round timing information.
 * Updates every second to show countdown to current round expiry.
 */
export function useRoundTimer() {
  const [roundInfo, setRoundInfo] = useState<RoundInfo>(() =>
    RoundService.getCurrentRoundInfo(),
  );
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() =>
    RoundService.getTimeLeftInCurrentRound(),
  );

  useEffect(() => {
    // Update immediately
    setRoundInfo(RoundService.getCurrentRoundInfo());
    setTimeLeft(RoundService.getTimeLeftInCurrentRound());

    // Then update every second
    const interval = setInterval(() => {
      setRoundInfo(RoundService.getCurrentRoundInfo());
      setTimeLeft(RoundService.getTimeLeftInCurrentRound());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    roundInfo,
    timeLeft,
    formatTime: () => RoundService.formatTimeLeft(timeLeft),
    currentRoundExpiry: roundInfo.currentRoundExpiry,
    timeToExpiryHours: roundInfo.timeToExpiryHours,
    isExpired: roundInfo.isExpired,
  };
}
